import { render, staticRenderFns } from "./Experience.vue?vue&type=template&id=06278282&scoped=true&"
import script from "./Experience.vue?vue&type=script&lang=ts&"
export * from "./Experience.vue?vue&type=script&lang=ts&"
import style0 from "./Experience.vue?vue&type=style&index=0&id=06278282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06278282",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
